import { BadgeCheck } from "lucide-react";

const SIZES = {
  sm: "text-[11px] px-2 py-0.5 gap-1",
  md: "text-xs px-3 py-1 gap-1.5",
};

export const FreeOrgBadge = ({ size = "md", variant = "light", label = "Gratuit", className = "", testId = "free-org-badge" }) => (
  <span
    data-testid={testId}
    className={`inline-flex items-center rounded-full font-bold uppercase tracking-wider ${SIZES[size]} ${
      variant === "dark"
        ? "bg-emerald-400/15 text-emerald-300 border border-emerald-400/30"
        : "bg-emerald-50 text-emerald-800 border border-emerald-200"
    } ${className}`}
  >
    <BadgeCheck size={size === "sm" ? 12 : 14} /> {label}
  </span>
);

export const FREE_ORG_TEXT = "Totalement gratuit pour les organismes (CSE, associations, clubs sportifs)";

export default FreeOrgBadge;
